exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".leavingRoomMenu__listWrap{display:flex;justify-content:start;flex-wrap:wrap}.leavingRoomMenu__list{width:100%;margin:0 0 15px}.leavingRoomMenu__imgBlock{display:block;width:100%;margin:15px 0 0}.leavingRoomMenu__img{width:100%}.leavingRoomMenu__link{letter-spacing:-.5px}@media only screen and (min-width:480px){.leavingRoomMenu__list{width:33%}.leavingRoomMenu__imgBlock{margin:15px 0 0}}@media only screen and (min-width:992px){.leavingRoomMenu__link{letter-spacing:normal}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34b5ba5e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mainMenuLeavingRoom.vue
// module id = 197
// module chunks = 0